/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOperatingAreaDto
 */
export interface CreateOperatingAreaDto {
    /**
     * Country code (ISO 3166-1 alpha-3)
     * @type {string}
     * @memberof CreateOperatingAreaDto
     */
    countryCode: string;
    /**
     * Admin area 1 code (province/state) - optional for country-wide access
     * @type {string}
     * @memberof CreateOperatingAreaDto
     */
    adminArea1Code?: string;
    /**
     * Admin area 2 code (city/district) - optional for province-wide access
     * @type {string}
     * @memberof CreateOperatingAreaDto
     */
    adminArea2Code?: string;
}

/**
 * Check if a given object implements the CreateOperatingAreaDto interface.
 */
export function instanceOfCreateOperatingAreaDto(value: object): value is CreateOperatingAreaDto {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function CreateOperatingAreaDtoFromJSON(json: any): CreateOperatingAreaDto {
    return CreateOperatingAreaDtoFromJSONTyped(json, false);
}

export function CreateOperatingAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOperatingAreaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'adminArea1Code': json['adminArea1Code'] == null ? undefined : json['adminArea1Code'],
        'adminArea2Code': json['adminArea2Code'] == null ? undefined : json['adminArea2Code'],
    };
}

export function CreateOperatingAreaDtoToJSON(value?: CreateOperatingAreaDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
        'adminArea1Code': value['adminArea1Code'],
        'adminArea2Code': value['adminArea2Code'],
    };
}

